import { find, remove, shuffle, isEqual } from "lodash";
import DragSortableList from "react-drag-sortable";
import React from "react";
// import { CorrectAnswer } from "../../components/answers/correct_answer";
// import { WrongAnswer } from "../../components/answers/wrong_answer";
import { Answer } from "../../components/answers/badge/answer";
import { DragAndDropOptionorderReview } from "./DragAndDrop_Optionorder_Review";
import ReactHtmlParser from "react-html-parser";

export const OrderDragDrop = React.memo(({ 
  question,
  exercise_id,
  section_id,
  page_id,
  data_possible_type,
  qai,
  answers, 
  isReview ,
  Questionedit,
}) => {
  let PossibleOptions = [];
  const converted_string = question.prompt_content.replace(
    /\[\[[^\]]*\]\]/g,
    function replacer(matched) {
      return `<input type='text' data-type='OrderDragDrop' >`;
    }
  );
 if (data_possible_type == "Exercise")
 {
    var onSort = function (sortedList) {
      let found_answer = find(answers, [
        "question_id",
        sortedList[0].question_id,
      ]);
      let question_id = sortedList[0].question_id;
      let selected_answers = [];

      sortedList.forEach((sorted_list) => {
        if (found_answer) {
          let answer_index = answers.indexOf(found_answer);
          remove(
            answers,
            (answer_item_id) => answers.indexOf(answer_item_id) === answer_index
          );
        }
        selected_answers.push({
          number: sorted_list.rank + 1,
          id: sorted_list.possible_answer_id,
        });
      });
      answers.push({
        question_id: question_id,
        selected_answers: selected_answers,
      });
    };
 }
 else{
  var onSort = function (sortedList) {
    let found_answer = find(answers, [
      "question_id",
      sortedList[0].question_id,
    ]);
    let question_id = sortedList[0].question_id;
    let selected_answers = [];
    let found_section = find(answers, ["section_id", section_id]);
    let found_page = find(answers, ["page_id", page_id]);
    let found_exercise = find(answers, ["exercise_id", exercise_id]);
    if (found_section && found_page && found_exercise) {
      sortedList.forEach((sorted_list) => {
        if (found_answer) {
          let answer_index = answers.indexOf(found_answer);
          remove(
            answers,
            (answer_item_id) => answers.indexOf(answer_item_id) === answer_index
          );
        }
        selected_answers.push({
          number: sorted_list.rank + 1,
          id: sorted_list.possible_answer_id,
        });
      });
      let find_question = find( found_exercise.answers , ["question_id", question_id]);
      if (find_question) {
        find_question.selected_answers = selected_answers
      }
      else{
        found_exercise.answers.push({question_id, selected_answers: selected_answers});
      }
     
      } else {
      sortedList.forEach((sorted_list) => {
        if (found_answer) {
          let answer_index = answers.indexOf(found_answer);
          remove(
            answers,
            (answer_item_id) => answers.indexOf(answer_item_id) === answer_index
          );
        }
        selected_answers.push({
          number: sorted_list.rank + 1,
          id: sorted_list.possible_answer_id,
        });
      });
      answers.push({
        section_id: section_id,
        page_id: page_id,
        exercise_id: exercise_id,
        answers: [
          {
            question_id,
            selected_answers: selected_answers,
          },
        ],
      });
    }

  };
 }


  let question_options =
    question && question.question_options_randomize
      ? shuffle(question.possible_answers)
      : question.possible_answers;

  if (question && question.question_options_randomize) {
    Shuffle_options();
  }

  function Shuffle_options() {
    let shuffle_array = [];
    let correct_array = [];
    question_options.forEach((options) => {
      shuffle_array.push(options.prompt_content);
    });
    question.possible_answers.forEach((correct_answer) => {
      correct_array.push(correct_answer.prompt_content);
    });
    let is_equal = isEqual(shuffle_array, correct_array);

    if (!is_equal) {
      return;
    } else {
      question_options = shuffle(question.possible_answers);
      Shuffle_options();
    }
  }

  if (PossibleOptions.length === 0) {
    question_options.forEach((possible_answer) => {
      PossibleOptions.push({
        question_id: question.id,
        possible_answer_id: possible_answer.id,
        content: (
          <Answer
            class="badge inline dotted-border customized-badge pading"
            value={possible_answer.prompt_content}
            Questionedit={Questionedit}
          />
        ),
        classes: ["test mt-3 mb-1 me-2"],
      });
    });
  }

  let rendered = false;
  return (
    <div className="d-flex mb-3">
      <b className="me-2"> {qai + 1 + "."}</b>
      <div className="d-flex">
        {isReview ? (
          <DragAndDropOptionorderReview
            question={question}
            converted_string={converted_string}
            rendered = {rendered}
          />
        ) : (
          <div >
            <div>
              {ReactHtmlParser(converted_string, {
                transform: (node) => {
                  if (node.name === "input") {
                   
                    return !rendered ? (
                      <>
                        {(rendered = true)}
                        <div className="d-flex d-inline-flex align-bottom">
                        <DragSortableList
                          items={PossibleOptions}
                          moveTransitionDuration={0.3}
                          onSort={onSort}
                          type="grid"
                        />
                        </div>
                      </>
                    ) : null;
                  }
                },
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
